module.exports = __webpack_public_path__ + "img/horcrux-salazar-slitherin.d070641b.png";